export const filterByItemId = (messagelogbymessagetype, messageTypeId) => {
	let meetTheMessageType = messagelogbymessagetype.filter((type) => type === messageTypeId);
	if (meetTheMessageType.length === 0) return false;
	return true;
};

export const filterListByListValue = (filterList, messageList) => {
	if (messageList.length === 0) return false;

	let meetValues = [];

	filterList.forEach((itemId) => {
		let filtered = messageList.filter((item) => item.id === itemId);
		if (filtered.length > 0) {
			meetValues.push(filtered);
		}
	});

	if (meetValues.length === 0) return false;
	return true;
};

export const filterByToEntity = (filterList, messageList) => {
	if (messageList.length === 0) return false;

	let meetValues = [];

	filterList.forEach((itemId) => {
		let filtered = messageList.filter((item) => item.entityId === itemId);
		if (filtered.length > 0) {
			meetValues.push(filtered);
		}
	});

	if (meetValues.length === 0) return false;
	return true;
};

const meetsFilters = (
	filterTypes,
	messageTypeId,
	sentByUserId,
	from,
	entities,
	countries,
	groupRoles,
	engagements,
	serviceLine,
	roles
) => {
	const {
		messagelogbymessagetype,
		messagelogbysentby,
		messagelogbyfromentity,
		messagelogbytoentity,
		messagelogbytocountry,
		messagelogbytogrouprole,
		messagelogbytoengagement,
		messagelogbytoserviceline,
		messagelogbytorole
	} = filterTypes;

	if (messagelogbymessagetype?.length > 0 && !filterByItemId(messagelogbymessagetype, messageTypeId)) return false;
	if (messagelogbysentby?.length > 0 && !filterByItemId(messagelogbysentby, sentByUserId)) return false;
	if (messagelogbyfromentity?.length > 0 && !filterByItemId(messagelogbyfromentity, from.entityId)) return false;
	if (messagelogbytoentity?.length > 0 && !filterByToEntity(messagelogbytoentity, entities)) return false;
	if (messagelogbytocountry?.length > 0 && !filterListByListValue(messagelogbytocountry, countries)) return false;
	if (messagelogbytogrouprole?.length > 0 && !filterListByListValue(messagelogbytogrouprole, groupRoles)) return false;
	if (messagelogbytoengagement?.length > 0 && !filterListByListValue(messagelogbytoengagement, engagements))
		return false;
	if (messagelogbytoserviceline?.length > 0 && !filterListByListValue(messagelogbytoserviceline, serviceLine))
		return false;
	if (messagelogbytorole?.length > 0 && !filterListByListValue(messagelogbytorole, roles)) return false;
	return true;
};

const filterByOptions = (list, filterTypes) => {
	const filteredMessages = list.filter(
		({messageTypeId, sentByUserId, from, entities, countries, groupRoles, engagements, serviceLine, roles}) => {
			return meetsFilters(
				filterTypes,
				messageTypeId,
				sentByUserId,
				from,
				entities,
				countries,
				groupRoles,
				engagements,
				serviceLine,
				roles
			);
		}
	);

	if (filteredMessages.length !== 0) {
		return filteredMessages;
	}
	return [];
};

const hasFilters = (filterTypes) => {
	if (
		filterTypes.messagelogbymessagetype?.length > 0 ||
		filterTypes.messagelogbysentby?.length > 0 ||
		filterTypes.messagelogbyfromentity?.length > 0 ||
		filterTypes.messagelogbytoentity?.length > 0 ||
		filterTypes.messagelogbytocountry?.length > 0 ||
		filterTypes.messagelogbytogrouprole?.length > 0 ||
		filterTypes.messagelogbytoengagement?.length > 0 ||
		filterTypes.messagelogbytoserviceline?.length > 0 ||
		filterTypes.messagelogbytorole?.length > 0
	) {
		return true;
	}
	return false;
};

export default (normalizedFilters, normalizedMessages) => {
	const {filterTypes = null} = normalizedFilters;

	let filteredMessages = [...normalizedMessages];

	if (filterTypes && hasFilters(filterTypes)) filteredMessages = filterByOptions(filteredMessages, filterTypes);

	return filteredMessages;
};
